import { inject, Injectable } from '@angular/core';
import { USER_LOGGED_IN_STATUS } from '../../constants/utils';
import { adobePageLoadAnalyticsMocks } from '../../mocks/content-body-data/adobe-data-layer.mocks';
import {
  AnalyticsProfile,
  AnalyticsSiteAssets,
  AnalyticsUserAttributes,
  PageLoadAnalytics
} from '../../models/utils/analytics.interfaces';
import { UserSessionService } from '../../services/login/data-services/user-session/user-session.service';
import { AnalyticsService } from '../../services/utils/analytics/analytics.service';

Injectable({
  providedIn: 'root'
});
export class ContentBodyExtendedAdobeAnalyticsService {
  protected isLoggedInGlobal = false;
  protected userSession = inject(UserSessionService);
  protected analyticsService = inject(AnalyticsService);
  populateHomePageAssets(
    site_assets: AnalyticsSiteAssets[],
    isWarmState: boolean,
    analyticsProfile: AnalyticsProfile,
    isLoggedIn: boolean
  ): void {
    const { title, URL } = window.document;
    const userAttributes = this.getUserAttributes(isLoggedIn, isWarmState);
    const userProfile = isLoggedIn ? { profile: analyticsProfile } : {};

    const data: PageLoadAnalytics = {
      ...adobePageLoadAnalyticsMocks,
      page: {
        info: {
          ...adobePageLoadAnalyticsMocks.page.info,
          page_name: title,
          page_url: URL
        }
      },
      site_assets: site_assets,
      user: {
        attributes: userAttributes,
        ...userProfile
      }
    };
    this.analyticsService.setAnalytics(data);
  }

  private getUserAttributes(
    isLoggedIn: boolean,
    isWarmState: boolean
  ): AnalyticsUserAttributes {
    if (!isLoggedIn) {
      return {
        is_logged_in: USER_LOGGED_IN_STATUS.UNAUTHENTICATED
      };
    }
    return {
      is_logged_in: USER_LOGGED_IN_STATUS.AUTHENTICATED,
      login_state: this.getLoginState(isLoggedIn, isWarmState),
      login_method: 'skymiles'
    };
  }

  private getLoginState(isLoggedIn: boolean, isWarmState: boolean): string {
    if (isLoggedIn) return USER_LOGGED_IN_STATUS.HOT;
    return isWarmState
      ? USER_LOGGED_IN_STATUS.WARM
      : USER_LOGGED_IN_STATUS.COLD;
  }
}
